import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from "@angular/router";
import { Location } from "@angular/common";
import { MainserviceService } from './../mainservice.service';

import 'rxjs/add/operator/switchMap';

@Component({
  selector: 'app-shop-detail',
  templateUrl: './shop-detail.component.html',
  styleUrls: ['./shop-detail.component.scss']
})
export class ShopDetailComponent implements OnInit {

  shop:any;
  shopstat:any;
  


  constructor(
    private mainservice: MainserviceService,
    private route:ActivatedRoute,
    private location: Location
  ) { }

  ngOnInit() {
    this.route.paramMap.switchMap((params :ParamMap) =>
    this.mainservice.getShop(+params.get('id')))
  .subscribe( shop => { this.shop = shop
  
    this.mainservice.getShopPromoStats(shop.id).subscribe(data =>
    this.shopstat =data[0])
  
  })
  
  
  }

  goBack():void {
    this.location.back();
  }

}



// WEBPACK FOOTER //
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/shop-detail/shop-detail.component.ts